import ItemList from '@/controllers/item/item-list.js';
import axios from 'axios';
import CONFIG from '@/assets/js/config.custom';

export default {
  extends: ItemList,
  data() {
    return {
      CONFIG,
      academicYearArr: []
    }
  },

  methods: {
    getItem(page = 1) {
      axios.get('item/list?page=' + page)
        .then(res => {
          if (page > 1 && !res.data.data.length) {
            this.isLoading = true;
            this.getItem(page - 1);
          }

          if (res.data) {
            this.itemData = res.data;
            this.total = this.itemData.meta.total;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    search(page = 1) {
      this.clearValidationErrors();
      this.isLoading = true;
      const params = {
        itemName: this.searchData.itemName,
        fromAmt: this.searchData.fromAmt,
        toAmt: this.searchData.toAmt,
        academic_year: this.searchData.academic_year
      }
      this.searchedData = {
        ...this.searchData
      }
      this.isSearched = true;
      axios.get('item/search?page=' + page, { params })
        .then((res) => {
          this.isLoading = false;
          if (res.data) {
            this.itemData = res.data;
            this.total = this.itemData.meta.total;
          }
        }).catch(error => {
          this.printValidationError(error.response);
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getAcademicYear() {
      axios.get("period/periodList")
        .then(res => {
          this.academicYearArr = res.data.data;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    deleteItem(id) {
      const status = confirm("Are you sure want to delete this item?");

      if (!status) return;
      
      axios.delete(`item/delete/${id}`)
      .then(res => {
        this.getItem(this.itemData.current_page);
        this.$notification.success(res.data.message, {
          timer: 3,
          position: "bottomCenter"
        });
      })
      .catch(err => {
        if (err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }

        this.$notification.error(err.response.data.message, {
          timer: 3,
          position: "bottomCenter"
        });
      })
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
                      ? { ...this.searchedData, isSearched: true, academic_year: this.searchData.academic_year }
                      : { isSearched: false };
      axios.get('/item/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          let date = new Date();
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `payment_item_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getAcademicYear();
  }
}
